module.exports = __webpack_public_path__ + "img/product_8.806cb42.webp";